import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faImage, faVectorSquare, faFileCsv } from "@fortawesome/free-solid-svg-icons";

const ExportTab = ({ graphRef }) => {
    const handleExportGraph = (format) => {
        if (graphRef.current && graphRef.current.exportGraph) {
            graphRef.current.exportGraph(format);
        }
    };

    const handleExportData = () => {
        if (graphRef.current && graphRef.current.exportData) {
            graphRef.current.exportData();
        }
    };

    return (
        <div className="row">
            <div className="col-md-12 mb-3">
                <div className="d-flex gap-2">
                    <Button variant="primary" size="sm" onClick={() => handleExportGraph("png")}>
                        <FontAwesomeIcon icon={faImage} className="me-2"/>
                        PNG
                    </Button>
                    <Button variant="primary" size="sm" onClick={() => handleExportGraph("jpeg")}>
                        <FontAwesomeIcon icon={faImage} className="me-2"/>
                        JPEG
                    </Button>
                    <Button variant="primary" size="sm" onClick={() => handleExportGraph("svg")}>
                        <FontAwesomeIcon icon={faVectorSquare} className="me-2"/>
                        SVG
                    </Button>
                    <Button variant="success" size="sm" onClick={handleExportData}>
                        <FontAwesomeIcon icon={faFileCsv} className="me-2"/>
                        CSV Data
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default ExportTab;